var FileType;
(function (FileType) {
  FileType["PDF"] = ".pdf,application/pdf";
  FileType["JPG"] = ".jpg,.jpeg,image/jpeg";
  FileType["PNG"] = ".png,image/png";
  FileType["CSV"] = ".csv,text/csv";
})(FileType || (FileType = {}));

export { FileType };
//# sourceMappingURL=fileType.mjs.map
